import{useState as e,useEffect as t}from"react";const n=()=>{const[n,o]=e(null),c=e=>{o(document.activeElement)};return t((()=>(document.addEventListener("focusin",c),()=>{document.removeEventListener("focusin",c)})),[]),n};export{n as useActiveElement};
//# sourceMappingURL=use-active-element.js.map
